 /** Published Chrome Web Store listing for the SohozKaj Autofill extension. */
export const EXTENSION_DOWNLOAD_URL =
    'https://chromewebstore.google.com/detail/sohozkaj-autofill/fddapaeieojijagpdmmaihieeiikhnbf';

/** Published Firefox Add-ons (AMO) listing for the SohozKaj Autofill extension. */
export const EXTENSION_DOWNLOAD_URL_FIREFOX =
    'https://addons.mozilla.org/en-US/firefox/addon/sohozkaj-autofill/';

/**
 * Which browser's extension store to show the visitor.
 * Firefox (desktop + Firefox-for-Android) gets the AMO flow; every Chromium browser
 * (Chrome, Edge, Brave, Opera, …) falls back to the Chrome Web Store default.
 */
export function detectExtensionBrowser() {
    if (typeof navigator === 'undefined') return 'chrome';
    const ua = navigator.userAgent || '';
    if (/\b(firefox|fxios)\b/i.test(ua)) return 'firefox';
    return 'chrome';
}
